<mat-icon (click)="closeDialog()" [style]="'margin-bottom: 2vh;'">clear</mat-icon>
<div id="extra-spacing">Location Overrides</div>
<div class="mat-elevation-z2 table-container">
    <table *ngIf="formattedOverrides?.length !== 0" mat-table [dataSource]="formattedOverrides"
           aria-describedby="unpublished changes">

        <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef class="text-wrapper">Location</th>
            <td mat-cell *matCellDef="let row" class="text-wrapper">{{ row.key }}</td>
        </ng-container>

        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="text-wrapper">Override Value</th>
            <td mat-cell *matCellDef="let row" class="text-wrapper">{{ row.value }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
<div *ngIf="formattedOverrides?.length === 0 || !formattedOverrides" style="text-align: center">
    There are no overrides for {{ this.data.attribute.name }}
</div>
